import React from "react";
import { MemberLogin } from "./view/memberLogin";

export const renderRule = {
  match: (item, cmsOption) => item.itemTypeCode === "MemberLogin",
  itemElt: (item, cmsOption) => (
    <MemberLogin item={item} cmsOption={cmsOption} />
  ),
};
